import { SiteHeader } from "@/components/SiteChrome";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Overview, Students, Purchases } from "@/pages/admin/AdminPeople";
import { ContentEditor } from "@/pages/admin/AdminContent";
import { ScriptsVideos } from "@/pages/admin/AdminScripts";
import { CoachInsights } from "@/pages/admin/AdminCoach";

const TABS = [["overview", "Overview", Overview], ["students", "Students", Students], ["purchases", "Purchases", Purchases],
  ["content", "Lessons & files", ContentEditor], ["scripts", "Videos & scripts", ScriptsVideos], ["coach", "AI coach", CoachInsights]];

export default function AdminPage() {
  return (
    <div className="min-h-screen pb-20">
      <SiteHeader links={false} />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-8 space-y-6">
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Admin</h1>
        <Tabs defaultValue="overview">
          <TabsList className="flex flex-wrap h-auto gap-1 bg-white border border-slate-200 p-1 rounded-xl justify-start">
            {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} className="rounded-lg data-[state=active]:bg-teal-600 data-[state=active]:text-white" data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>)}
          </TabsList>
          {TABS.map(([v, , C]) => <TabsContent key={v} value={v} className="mt-6"><C /></TabsContent>)}
        </Tabs>
      </main>
    </div>
  );
}
